import { arrayOf, number, shape, string } from 'prop-types'

export const searchFilterType = shape({
  from: number,
  to: number,
  limit: number,
  limitOptions: arrayOf(number),
  sortBy: string,
  sortByOptions: arrayOf(string),
})
